import { ancestorCrumbs } from './collectionFamily';
import { normalizeId } from './ids';

/**
 * Breadcrumb trails for the context bar. The breadcrumb names the containers
 * above the object on screen and replaces every "back to…" link:
 *
 *   Collections / {Collection}            (an item, a form, settings)
 *   Collections / {Collection} / {sub}
 *   Collections / {Parent} / {Collection} / {sub}   (in a sub-collection)
 *
 * A sub-collection's ancestors come from `collection.hierarchy`
 * (utils/collectionFamily.js); one the viewer cannot open is a plain
 * segment, never a link.
 *
 * Each crumb is { label, to? }; the last one is usually unlinked.
 */
/** The first crumb of a page that belongs to no collection (a tag, a combined list). */
export const HOME_CRUMB = Object.freeze({ label: 'Home', to: '/' });
export const COLLECTIONS_CRUMB = { label: 'Collections', to: '/collections' };
export const CARDS_CRUMB = { label: 'Cards', to: '/cards' };

export function collectionCrumbs(collection, collectionId, ...more) {
	const id = normalizeId(collectionId) || normalizeId(collection?._id);
	const crumbs = [COLLECTIONS_CRUMB, ...ancestorCrumbs(collection)];
	if (collection || id) {
		crumbs.push({
			label: collection?.name || 'Collection',
			to: id ? `/collections/${id}/items` : undefined,
		});
	}
	more.filter(Boolean).forEach(crumb => {
		crumbs.push(typeof crumb === 'string' ? { label: crumb } : crumb);
	});
	return crumbs;
}
